import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Product } from '../../../shared/interfaces/product';
import { EMPTY, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { RootService } from '../../../shared/services/root.service';
import { ShopService } from '../../../shared/services/shop.service';

@Injectable({
    providedIn: 'root'
})
export class ProductResolverService implements Resolve<Product> {
    constructor(
        private root: RootService,
        private router: Router,
        private shop: ShopService,
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Product> {
        const productSlug = route.params.productSlug || route.data.productSlug;
        return this.shop.getoneproductbyslug(productSlug).pipe(
            catchError(error => {
                if (error instanceof HttpErrorResponse && error.status === 404) {
                    this.router.navigate([this.root.notFound()]).then();
                }
                return EMPTY;
            })
        );
        // return this.shop.getProduct(productSlug).pipe(
        //     catchError(error => {
        //         if (error instanceof HttpErrorResponse && error.status === 404) {
        //             this.router.navigate([this.root.notFound()]).then();
        //         }
        //         return EMPTY;
        //     })
        // );
    }
}
